import { render, staticRenderFns } from "./ReportInfoDialog.vue?vue&type=template&id=1fa06fc2&scoped=true&"
import script from "./ReportInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./ReportInfoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReportInfoDialog.vue?vue&type=style&index=0&id=1fa06fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa06fc2",
  null
  
)

export default component.exports